export const typeGasketMaterial = [

   {
      title: 'Adhesive Backed High-Strength Multipurpose Neoprene Rubber Durometer 50A (36" Wide , 1/16" Thickness)'
   },
   {
      title: 'Oil - Resistant Neoprene / Vinyl / Buna - N Foam (54" Wide ,  1/8" Thickness)'
   },
   {
      title: 'High-Strength Multipurpose Neoprene Rubber Durometer 40A (36" Wide , 1/16" Thickness)'
   },
   {
      title: 'High-Strength Multipurpose Neoprene Rubber Durometer 60A (36" Wide , 1/16" Thickness)'
   },
   {
      title: 'Multipurpose Oil-Resistant Gasket Material, Aramid/Buna-N Sheet Automotive Style (60" x30" , 1/32" Thickness)'
   }, {
      title: 'Multipurpose Oil-Resistant Gasket Material, Aramid/Buna-N Sheet Automotive Style (60" x30" , 1/16" Thickness)'
   }, {
      title: 'Other'
   },
]